import ParameterFieldBase from '../../../../_common/platform/ts/ParameterFieldBase';
import EditComponent, { IChartStripsField_inThemesOptions } from './ChartStripsField_inThemes';

export class ChartStripsField_inThemes extends ParameterFieldBase<IChartStripsField_inThemesOptions> {
    public static EditComponent = EditComponent;
    public static getDefaultValue() {
        return [];
    }

    constructor(glob, title: string, validators?: any, defaultVal?: any, options?: IChartStripsField_inThemesOptions) {
        if (defaultVal == null) {
            defaultVal = ChartStripsField_inThemes.getDefaultValue();
        }

        super(glob, title, [], validators, defaultVal, options);
    }
}
